<template>
  <b-form @submit.prevent autocomplete="off">
    <div class="white-section box-info pt-3 mb-2">
      <section class="box-has-title mb-3">
        <input type="password" autocomplete="off" hidden />
        <input type="text" autocomplete="off" hidden />
        <!-- <b-col md="12">
          <hr :data-content="$t('user.personalInfo')" class="hr-text" />
        </b-col> -->
        <b-row>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :label="$t('user.gender')"
              label-for="user-gender"
              :invalid-feedback="
                invalidFeedbackGender
                  ? $t(`validation.${invalidFeedbackGender}`, {
                      field: $t('user.gender'),
                    })
                  : ''
              "
              :class="{ 'required-group': !$v.gender.required }"
              :state="
                $v.gender.$dirty
                  ? !$v.gender.$invalid === false
                    ? false
                    : null
                  : null
              "
            >
              <b-form-radio-group
                id="user-gender"
                ref="gender"
                v-model="gender"
                :options="genders"
                :state="
                  $v.gender.$dirty
                    ? !$v.gender.$invalid === false
                      ? false
                      : null
                    : null
                "
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="invalidUserName(invalidFeedbackUsername)"
              :label="$t('user.username')"
              :state="
                $v.username.$dirty
                  ? !$v.username.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.username.required }"
              label-for="user-username"
            >
              <b-form-input
                id="user-username"
                v-model="username"
                :state="
                  $v.username.$dirty
                    ? !$v.username.$invalid === false
                      ? false
                      : null
                    : null
                "
                @input="$v.username.$touch()"
                @keypress="onlyEnglish($event)"
                dir="ltr"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="invalidPassword(invalidFeedbackPassword)"
              :label="$t('user.password')"
              :state="
                $v.password.$dirty
                  ? !$v.password.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.password.required }"
              label-for="user-password"
              dir="ltr"
            >
              <b-input-group>
                <template #append>
                  <b-button
                    variant="outline-secondary"
                    @click="togglePasswordEye"
                  >
                    <template v-if="passwordType === 'text'">
                      <feather-icon icon="EyeIcon" />
                    </template>
                    <template v-else>
                      <feather-icon icon="EyeOffIcon" />
                    </template>
                  </b-button>
                  <b-form-input
                    id="user-password"
                    v-model="password"
                    :state="
                      $v.password.$dirty
                        ? !$v.password.$invalid === false
                          ? false
                          : null
                        : null
                    "
                    aria-describedby="user-password-feedback"
                    :type="passwordType"
                    @input="$v.password.$touch()"
                    v-on:keypress="isLetter($event)"
                    autocomplete="off"
                  />
                </template>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackConfirm
                  ? $t(`validation.${invalidFeedbackConfirm}`, {
                      field: $t('user.confirm'),
                    })
                  : ''
              "
              :label="$t('user.confirm')"
              :state="
                $v.confirm.$dirty
                  ? !$v.confirm.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.confirm.required }"
              label-for="user-confirm"
            >
              <b-input-group>
                <template #append>
                  <b-form-input
                    id="user-confirm"
                    v-model="confirm"
                    :state="
                      $v.confirm.$dirty
                        ? !$v.confirm.$invalid === false
                          ? false
                          : null
                        : null
                    "
                    aria-describedby="user-confirm-feedback"
                    :type="confirmPasswordType"
                    @input="$v.confirm.$touch()"
                    v-on:keypress="isLetter($event)"
                    dir="ltr"
                    autocomplete="off"
                  />
                  <b-button
                    variant="outline-secondary"
                    @click="toggleConfirmPasswordEye"
                  >
                    <template v-if="confirmPasswordType === 'text'">
                      <feather-icon icon="EyeIcon" />
                    </template>
                    <template v-else>
                      <feather-icon icon="EyeOffIcon" />
                    </template>
                  </b-button>
                </template>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackRole
                  ? $t(`validation.${invalidFeedbackRole}`, {
                      field: $t('user.role'),
                    })
                  : ''
              "
              :label="$t('user.role')"
              label-for="user-role"
              :state="
                $v.role.$dirty
                  ? !$v.role.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{
                'required-group': !$v.role.required,
              }"
            >
              <my-v-select
                v-if="roles && roles.length > 0"
                v-model="role"
                :multiple="true"
                :options="roles.length ? roles : null"
                :translate="true"
                :concat-label="['title']"
                translateObj="role"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackUnit
                  ? $t(`validation.${invalidFeedbackUnit}`, {
                      field: $t('user.unit'),
                    })
                  : ''
              "
              :label="$t('user.unit')"
              :state="
                $v.unit.$dirty
                  ? !$v.unit.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{
                'required-group': !$v.unit.required,
              }"
              label-for="count-of-queue"
            >
              <my-v-select
                v-if="units && units.length > 0"
                :options="units.length ? units : null"
                v-model="unit"
                custom-class="w-100 mr-2"
                :multiple="true"
                :concat-label="['title']"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackFirstName
                  ? $t(`validation.${invalidFeedbackFirstName}`, {
                      field: $t('user.firstName'),
                    })
                  : ''
              "
              :label="$t('user.firstName')"
              :state="
                $v.firstName.$dirty
                  ? !$v.firstName.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.firstName.required }"
              label-for="user-first-name"
            >
              <b-form-input
                id="user-first-name"
                v-model="firstName"
                :state="
                  $v.firstName.$dirty
                    ? !$v.firstName.$invalid === false
                      ? false
                      : null
                    : null
                "
                @keydown="preventNumbers($event)"
                autocomplete="off"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackLastname
                  ? $t(`validation.${invalidFeedbackLastname}`, {
                      field: $t('user.lastName'),
                    })
                  : ''
              "
              :label="$t('user.lastName')"
              :state="
                $v.lastName.$dirty
                  ? !$v.lastName.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.lastName.required }"
              label-for="user-lastname"
            >
              <b-form-input
                id="user-lastname"
                v-model="lastName"
                :state="
                  $v.lastName.$dirty
                    ? !$v.lastName.$invalid === false
                      ? false
                      : null
                    : null
                "
                @input="$v.lastName.$touch()"
                @keydown="preventNumbers($event)"
                autocomplete="off"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :label="$t('user.nationality')"
              label-for="user-nationality"
            >
              <my-v-select
                v-if="countries && countries.length > 0"
                :key="country"
                id="user-nationality"
                v-model="country"
                :multiple="false"
                :options="countries.length ? countries : []"
                :translate="false"
                :concat-label="['title.fa']"
                :reduce-field="['_id']"
                :searchable="true"
                :filterable="true"
                @input="countrySelected"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="3" xl="2" v-if="isForeigner">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackFatherName
                  ? $t(`validation.${invalidFeedbackFatherName}`, {
                      field: $t('user.fathersName'),
                    })
                  : ''
              "
              :label="$t('user.fathersName')"
              :state="
                $v.fatherName.$dirty
                  ? !$v.fatherName.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.fatherName.required }"
              label-for="user-fatherName"
            >
              <div class="form-label-group">
                <b-form-input
                  id="user-fatherName"
                  v-model="fatherName"
                  :state="
                    $v.fatherName.$dirty
                      ? !$v.fatherName.$invalid === false
                        ? false
                        : null
                      : null
                  "
                  @keydown="preventNumbers($event)"
                />
              </div>
            </b-form-group>
          </b-col>
          <!-- <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :label="$t('user.dialCode')"
              label-for="user-mobile-dialcode"
            >
              <my-v-select
                v-if="countries && countries.length > 0"
                :key="mobileCountryId"
                id="user-mobile-dialcode"
                v-model="mobileCountryId"
                :multiple="false"
                :options="countries.length ? countries : []"
                :translate="false"
                :concat-label="['title.fa', 'phoneCode']"
                :refuce-field="['_id']"
                :searchable="true"
                :filterable="true"
                @input="countrySelected"
              />
            </b-form-group>
          </b-col> -->
          <!-- Item Mobile -->
          <b-col lg="3" md="4" sm="6" xl="2" v-if="!ShowNationalCode">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackNationalCode
                  ? $t(`validation.${invalidFeedbackNationalCode}`, {
                      field: $t('user.nationalCode'),
                    })
                  : ''
              "
              :label="$t('user.nationalCode')"
              :state="
                $v.nationalCode.$dirty
                  ? !$v.nationalCode.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.nationalCode.required }"
              label-for="user-nationalcode"
            >
              <b-form-input
                id="user-nationalcode"
                v-model="nationalCode"
                :state="
                  $v.nationalCode.$dirty
                    ? !$v.nationalCode.$invalid === false
                      ? false
                      : null
                    : null
                "
                aria-describedby="user-nationalcode-feedback"
                type="number"
                @input="$v.nationalCode.$touch()"
                @keypress="preventNationalType($event)"
                dir="ltr"
                autocomplete="off"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackMobile
                  ? $t(`validation.${invalidFeedbackMobile}`, {
                      field: $t('user.mobile'),
                      current: $t('user.anotherMobile'),
                    })
                  : ''
              "
              :label="$t('user.mobile')"
              :state="
                $v.mobile.$dirty
                  ? !$v.mobile.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{ 'required-group': !$v.mobile.required }"
              label-for="user-mobile"
            >
              <!-- :state="$v.mobiles.$dirty ? !$v.mobile.$invalid : null" -->
              <!-- :state="$v.mobile.$dirty ? !$v.mobile.$invalid : null" -->
              <b-form-input
                id="user-mobile"
                v-model="mobile"
                :state="
                  $v.mobile.$dirty
                    ? !$v.mobile.$invalid === false
                      ? false
                      : null
                    : null
                "
                aria-describedby="user-mobile-help"
                type="text"
                @keypress="preventMobileType($event)"
                dir="ltr"
                autocomplete="off"
              />
              <b-form-text v-if="hint" id="user-mobile-help"
                >{{ $t("hint.mobile") }}
              </b-form-text>
            </b-form-group>
          </b-col>
          
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :label="$t('user.dialCode')"
              label-for="user-mobile-dialcode"
            >
              <v-select
              :items="countriesWithCode"
              v-model="mobileCountryId"
              :key="mobileCountryId"
              id="user-mobile-dialcode"
              item-text="titleAndCode"
              item-value="_id"
              @input="countrySelected"
              attach
              class="selectCountri"
              :searchable="true"
              :filterable="true"
            >
            <template v-slot:selection="{ item }">
              <img :src="item.wikipedia_image" style="width:20px; height:20px; margin-right:10px; margin-left:10px">
              {{ item.phoneCode }}
            </template>
              <template v-slot:item="{ item }">
                <img :src="item.wikipedia_image" style="width:20px; height:20px; margin-right:10px ; margin-left:10px">
                {{ item.phoneCode }}
              </template>
            </v-select>
            </b-form-group>

          </b-col>
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackSpeciality
                  ? $t(`validation.${invalidFeedbackSpeciality}`, {
                      field: $t('user.medicalSpecialtyId'),
                    })
                  : ''
              "
              :label="$t('user.medicalSpecialtyId')"
              label-for="user-speciality"
              :state="
                $v.medicalSpecialtyId.$dirty
                  ? !$v.medicalSpecialtyId.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{
                'required-group': !$v.medicalSpecialtyId.required,
              }"
            >
              <my-v-select
                :key="medicalSpecialtyId"
                id="user-speciality"
                v-if="medicalSpecialties && medicalSpecialties.length > 0"
                :translate="false"
                v-model="medicalSpecialtyId"
                :concat-label="['title']"
                :options="medicalSpecialties.length ? medicalSpecialties : []"
                :multiple="false"
                :searchable="true"
                :filterable="true"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </section>
    </div>
    <div class="white-section">
      <b-row>
        <!-- submit and reset -->
        <b-col class="text-right" md="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size=""
            type="submit"
            variant="info"
            @click="registerUser"
          >
            {{ $t("general.submit") }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-form>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import dateFormat from "@/mixins/dateFormat";
import onlyEnglish from "@/mixins/onlyEnglish";
import nationalCodeValidation from "@/mixins/validations/nationalCode";
import mobileRepeaterBasic from "@/components/user/mobile-repeater/MobileRepeaterBasic";
import mobileValidation from "@/mixins/validations/mobile";
import postalCodeValidation from "@/mixins/validations/postalCode";
import addressRepeaterBasic from "@/components/user/address-repeater/AddressRepeaterBasic";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import phoneRepeaterBasic from "@/components/user/phone-repeater/PhoneRepeaterBasic";
import userSpouseRepeater from "@/components/user/user-spouse-repeater/UserSpouseRepeater.vue";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BFormInvalidFeedback,
  BFormSelectOption,
  BFormRadioGroup,
  BFormText,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import filterRoles from "@/mixins/filterRoles";
// import medicalSpecialties from "@/store/medicalSpecialties";
import Section from "@/views/baseInfo/structure/sections/Section";
import DoctorInfoSection from "@/components/user/doctor/DoctorInfoSection";
import DoctorAccountInfo from "@/components/user/doctor/DoctorAccountInfo";
import NurseAndMidwifeInfo from "@/components/user/nurse/NurseAndMidwifeInfo";
import ForeignerInfo from "@/components/user/Foreigner/ForeignerInfo";
import legalExpert from "@/components/user/legalExpert/LegalExpert";

export default {
  components: {
    ForeignerInfo,
    NurseAndMidwifeInfo,
    DoctorAccountInfo,
    DoctorInfoSection,
    Section,
    MyVSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    mobileRepeaterBasic,
    addressRepeaterBasic,
    phoneRepeaterBasic,
    BFormSelectOption,
    BFormRadioGroup,
    BFormText,
    userSpouseRepeater,
    MyAbDatePicker,
    legalExpert,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      passwordType: "password",
      confirmPasswordType: "password",
      isForeigner: false,
      ShowNationalCode: false,
      hint: true,
    };
  },
  created() {
    this.pushBreadcrumb({
      text: "addUser",
      to: { name: "addUser" },
      translate: true,
    });
    this.setCurrentBreadcrumb([
      { text: "addUser", to: { name: "addUser" }, translate: true },
    ]);
    this.$store.commit("user/RESET_MODULE");
    this.$store.dispatch("medicalSpecialties/getActiveMedicalSpecialty");
    this.$store.dispatch("location/countries").then((countries) => {
      let iran = countries.find((c) => c["alpha_2"] === "IR")._id;
      this.country = iran;
      this.mobileCountryId = iran;
      this.countrySelected();
    });
    this.$store.dispatch("getRoles").then((roles) => {
      // SET DEFAULT ROLE //
      // this.role.push(
      //   roles.find((r) => {
      //     return r.title === "doctor";
      //   })._id
      // );
    });
    this.gender="female"
    this.$store.dispatch("units/searchUnit", {
      status:"active",
    });
  },
  mixins: [
    nationalCodeValidation,
    dateFormat,
    mobileValidation,
    postalCodeValidation,
    onlyEnglish,
    filterRoles,
  ],
  validations() {
    return {
      gender: {
        required,
      },
      nationalCode: {
        required: requiredIf(() => {
          return this.ShowNationalCode
            ? ""
            : (this.nationalCodeValidation = (value) =>
                this.nationalCodeValidation(value));
        }),
        maxLength: maxLength(10),
      },
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      username: {
        required,
        minLength: minLength(4),
      },
      password: {
        required,
        minLength: minLength(6),
      },
      confirm: {
        required,
        sameAsPassword: sameAs("password"),
      },
      role: {
        required,
      },
      unit: {
        required,
      },
      mobile: {
        required,
      },
      medicalSpecialtyId: {
        required: requiredIf(() => {
          return this.role.find((r) => r === this.filterRoles("doctor"));
        }),
      },
      fatherName: {
        required: requiredIf(() => {
          return (
            this.isForeigner &&
            this.role.find(
              (r) =>
                r === this.filterRoles("patient") ||
                r === this.filterRoles("nurse") ||
                r === this.filterRoles("midwife")
            )
          );
        }),
      },
    };
  },
  computed: {
    ...mapGetters({
      genders: "user/genders",
      valid: "validation/valid",
      countries: "location/countries",
      cities: "location/cities",
      roles: "roles",
      units: "units/units",
      medicalSpecialties: "medicalSpecialties/medicalSpecialties",
    }),
    role: {
      set(role) {
        this.$store.commit("user/SET_ROLE", role);
      },
      get() {
        return this.$store.getters["user/role"];
      },
    },
    unit: {
      set(unit) {
        this.$store.commit("user/SET_UNIT", unit);
      },
      get() {
        return this.$store.getters["user/unit"];
      },
    },
    firstName: {
      set(name) {
        this.$store.commit("user/SET_FIRSTNAME", name);
      },
      get() {
        return this.$store.getters["user/firstName"];
      },
    },
    lastName: {
      set(lastName) {
        this.$store.commit("user/SET_LASTNAME", lastName);
      },
      get() {
        return this.$store.getters["user/lastName"];
      },
    },
    username: {
      set(username) {
        this.$store.commit("user/SET_USERNAME", username);
      },
      get() {
        return this.$store.getters["user/username"];
      },
    },
    password: {
      set(password) {
        this.$store.commit("user/SET_PASSWORD", password);
      },
      get() {
        return this.$store.getters["user/password"];
      },
    },
    confirm: {
      set(confirm) {
        this.$store.commit("user/SET_CONFIRM", confirm);
      },
      get() {
        return this.$store.getters["user/confirm"];
      },
    },
    nationalCode: {
      set(nationalCode) {
        this.$store.commit("user/SET_NATIONALCODE", nationalCode);
      },
      get() {
        return this.$store.getters["user/nationalCode"];
      },
    },
    mobile: {
      set(mobile) {
        this.$store.commit("user/SET_MOBILE", mobile);
      },
      get() {
        return this.$store.getters["user/mobile"];
      },
    },
    mobileCountryId: {
      set(mobileCountryId) {
        this.$store.commit("user/SET_MOBILE_COUNTRY_ID", mobileCountryId);
      },
      get() {
        return this.$store.getters["user/mobileCountryId"];
      },
    },
    country: {
      set(country) {
        // console.log(country);
        this.$store.commit("user/SET_COUNTRY", country);
      },
      get() {
        // console.log(this.$store.getters["user/country"]);
        return this.$store.getters["user/country"];
      },
    },
    gender: {
      set(gender) {
        this.$store.commit("user/SET_GENDER", gender);
      },
      get() {
        return this.$store.getters["user/gender"];
      },
    },
    fatherName: {
      set(fatherName) {
        this.$store.commit("user/SET_FATHERNAME", fatherName);
      },
      get() {
        return this.$store.getters["user/fatherName"];
      },
    },
    roleFilter: {
      set(role) {
        this.$store.commit("user/SET_ROLE_FILTER", role);
      },
      get() {
        return this.$store.getters["user/roleFilter"];
      },
    },
    medicalSpecialtyId: {
      set(medicalSpecialtyId) {
        this.$store.commit("user/SET_MEDICAL_SPECIALTY_ID", medicalSpecialtyId);
      },
      get() {
        return this.$store.getters["user/medicalSpecialtyId"];
      },
    },
    invalidFeedbackGender: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.gender.$dirty) return error;
        if (!this.$v.gender.required) error = "required";
        return error;
      },
    },
    invalidFeedbackFirstName: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.firstName.$dirty) return error;
        if (!this.$v.firstName.required) error = "required";
        return error;
      },
    },
    invalidFeedbackNationalCode: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.nationalCode.$dirty) return error;
        if (!this.$v.nationalCode.required) {
          error = "required";
          return error;
        }
        if (!this.$v.nationalCode.nationalCodeValidation) {
          error = "invalid";
          return error;
        }
        return error;
      },
    },
    invalidFeedbackMobile: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.mobile.$dirty) return error;
        if (!this.$v.mobile.required) {
          error = "required";
          return error;
        }
        // if (!this.$v.mobile.mobileValidation) {
        //   error = "invalid";
        //   return error;
        // }
        if (!this.$v.mobile.notTheSame) error = "notSameAs";
        return error;
      },
    },
    invalidFeedbackUsername: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.username.$dirty) return error;
        if (!this.$v.username.required) error = "required";
        if (!this.$v.username.minLength) error = "min";
        return error;
      },
    },
    invalidFeedbackPassword: {
      set(error) {},
      get() {
        var error = "";
        // console.log(this.$v.password.$dirty);
        if (!this.$v.password.$dirty) return error;
        if (!this.$v.password.required) error = "required";
        if (!this.$v.password.minLength) error = "min";
        return error;
      },
    },
    invalidFeedbackConfirm: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.confirm.$dirty) return error;
        if (!this.$v.confirm.sameAs) error = "sameAs";
        return error;
      },
    },
    invalidFeedbackRole: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.role.$dirty) return error;
        if (!this.$v.role.required) error = "required";
        return error;
      },
    },
    invalidFeedbackUnit: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.unit.$dirty) return error;
        if (!this.$v.unit.required) error = "required";
        return error;
      },
    },
    invalidFeedbackLastname: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.lastName.$dirty) return error;
        if (!this.$v.lastName.required) error = "required";
        return error;
      },
    },
    invalidFeedbackSpeciality: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.medicalSpecialtyId.$dirty) return error;
        if (!this.$v.medicalSpecialtyId.required) error = "required";
        return error;
      },
    },
    invalidFeedbackFatherName: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.fatherName.$dirty) return error;
        if (!this.$v.fatherName.required) error = "required";
        return error;
      },
    },
    countriesWithCode() {
      return this.countries.map(country => ({
        ...country,
        titleAndCode: `${country.phoneCode} `
      }));
    }
  },
  methods: {
    invalidUserName(value) {
      if (value) {
        switch (value) {
          case "required":
            return this.$t(`validation.required`, {
              field: this.$t("user.username"),
            });
          case "min":
            return this.$t(`validation.min`, {
              min: 4,
            });
        }
      } else return "";
    },
    // invalidNationalCode(value) {
    //   // console.log("wdwq", value);
    //   if (value) {
    //     switch (value) {
    //       case "required":
    //         return this.$t(`validation.required`, {
    //           field: this.$t("user.nationalCode"),
    //         });
    //       case "invalid":
    //         return this.$t(`validation.nationalCode`, {
    //           field: this.$t("user.nationalCode"),
    //         });
    //     }
    //   } else return "";
    // },
    invalidPassword(value) {
      if (value) {
        switch (value) {
          case "required":
            return this.$t(`validation.required`, {
              field: this.$t("user.password"),
            });
          case "min":
            return this.$t(`validation.min`, {
              min: 6,
            });
        }
      } else return "";
    },
    preventMobileType(value) {
      if (this.mobile.length >= 11) {
        value.preventDefault();
        return;
      }
    },
    preventNationalType(value) {
      if (this.nationalCode.length >= 10) {
        value.preventDefault();
        return;
      }
    },
    countrySelected() {
      let selected = this.countries.find((c) => {
        return c._id == this.country;
      });
      if (selected["alpha_2"] === "AF") {
        this.mobileCountryId = this.countries.find((c) => {
          return c["alpha_2"] === "AF";
        })._id;
        selected.phoneCode = 98;
      } else {
        this.mobileCountryId = this.country;
      }
      if (selected["alpha_2"] !== "AF" && selected["alpha_2"] !== "IR") {
        this.hint = false;
      } else {
        this.hint = true;
      }
      if (selected["alpha_2"] !== "IR") {
        this.isForeigner = true;
        this.ShowNationalCode = true;
      } else {
        this.isForeigner = false;
        this.ShowNationalCode = false;
      }
      if (selected["alpha_2"] == "IR") {
        this.isForeigner = false;
        this.birthCity = null;
      } else if (
        this.role.find(
          (r) =>
            r === this.filterRoles("patient") ||
            r === this.filterRoles("nurse") ||
            r === this.filterRoles("midwife")
        )
      ) {
        this.isForeigner = true;
      }
    },
    registerUser() {
      this.$v.$touch();
      
      var regex = new RegExp(
        "09(0[0-9]|1[0-9]|3[0-9]|2[0-9]|9[0-9])-?[0-9]{3}-?[0-9]{4}"
      );
      var result = regex.test(document.getElementById("user-mobile").value);
      if (
        (!this.$v.$invalid &&
          result &&
          this.hint == true &&
          this.ShowNationalCode == true) ||
        (!this.$v.$invalid &&
          !result &&
          this.hint == false &&
          this.ShowNationalCode == true)
      ) {
        let payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          username: this.username,
          password: this.password,
          gender: this.gender,
          mobile: this.mobile,
          mobileCountryId: this.mobileCountryId,
          countryId: this.country,
          status: "active",
          roles: this.role,
          units: this.unit,
          medicalSpecialtyId: this.medicalSpecialtyId ? this.medicalSpecialtyId : null,
          fatherName: this.fatherName,
        };
        this.$store
          .dispatch("user/registerUser", payload)
          .then((res) => {
            this.$store
              .dispatch("user/uploadDocs", res._id)
              .then((res) => {
                this.$bvToast.toast(
                  this.$t("toastification.submissionSucceed"),
                  {
                    variant: "success",
                    solid: true,
                  }
                );
                this.roleFilter = this.role;
                this.$router.push({ name: "manageUsers" });
              })
              .catch((error) => {
                this.$bvToast.toast(
                  this.$t("toastification.submissionFailed"),
                  {
                    variant: "danger",
                    solid: true,
                  }
                );
              });
          })
          .catch((error) => {
  
            if (error.message === "Error: Request failed with status code 400") {
              this.$bvToast.toast(this.$t("toastification.nationCodeLengthError"), {
                variant: "danger",
                solid: true,
              });
            }
            else {
              //console.log(error , 'e')

              this.$bvToast.toast(this.$t("toastification.nationCodeLengthError"), {
                variant: "danger",
                solid: true,
              });
            }
            
          });
      } else if (
        (!this.$v.$invalid &&
          result &&
          this.hint == true &&
          this.ShowNationalCode == false) ||
        (!this.$v.$invalid &&
          !result &&
          this.hint == false &&
          this.ShowNationalCode == false)
      ) {
        let payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          username: this.username,
          password: this.password,
          gender: this.gender,
          mobile: this.mobile,
          mobileCountryId: this.mobileCountryId,
          countryId: this.country,
          status: "active",
          roles: this.role,
          units: this.unit,
          medicalSpecialtyId: this.medicalSpecialtyId ? this.medicalSpecialtyId : null,
          nationalCode: this.nationalCode,
          fatherName: this.fatherName,
        };
        this.$store
          .dispatch("user/registerUser", payload)
          .then((res) => {
            this.$store
              .dispatch("user/uploadDocs", res._id)
              .then((res) => {
                this.$bvToast.toast(
                  this.$t("toastification.submissionSucceed"),
                  {
                    variant: "success",
                    solid: true,
                  }
                );
                this.roleFilter = this.role;
                this.$router.push({ name: "manageUsers" });
              })
              .catch((error) => {
                this.$bvToast.toast(
                  this.$t("toastification.submissionFailed"),
                  {
                    variant: "danger",
                    solid: true,
                  }
                );
              });
          })
          .catch((error) => {
            if (error.message === "Error: Request failed with status code 400") {
              this.$bvToast.toast(this.$t("toastification.nationCodeLengthError"), {
                variant: "danger",
                solid: true,
              });
            }
            else {
              this.$bvToast.toast(this.$t("toastification.submissionFailed"), {
                variant: "danger",
                solid: true,
              });
            }
          });
      } else if (!result && this.hint == true) {
        this.$bvToast.toast(this.$t("toastification.ErrorMobile"), {
          variant: "danger",
          solid: true,
        });
      }
      // else {
      //   const invalidFields = Object.keys(this.$v.$params).filter(
      //     (fieldName) => this.$v[fieldName].$invalid
      //   );
      //   this.$nextTick(() => {
      //     const el = document.querySelector(".is-invalid:first-of-type");
      //     
      //     el.scrollIntoView({ behavior: "instant", block: "center" });
      //     el.scrollIntoView();
      //     return;
      //   });
      // }
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (!/^[\u0600-\u06FF\s]+$/.test(char)) return true;
      else {
        e.preventDefault();
        this.$bvToast.toast(this.$t("toastification.changeLangToEn"), {
          variant: "danger",
          solid: true,
        });
      }
    },
    togglePasswordEye() {
      this.passwordType === "password"
        ? (this.passwordType = "text")
        : (this.passwordType = "password");
    },
    toggleConfirmPasswordEye() {
      this.confirmPasswordType === "password"
        ? (this.confirmPasswordType = "text")
        : (this.confirmPasswordType = "password");
    },
  },
};
</script>
<style scoped lang="scss">
input:read-only {
  background-color: #ffffff;
  border: 1px solid #cccccc;
  padding: 5px;
}
.input-group {
  height: 32px;
  display: flex;
  overflow: hidden;
  border: 1px solid #d8d6de;
  border-radius: 6px;
  input {
    border: none !important;
    height: 100%;
    border-radius: 0;
  }
}
.input-group-append {
  margin-left: 1 !important;
  width: 100%;

  button {
    padding: 0;
    width: 40px;
    min-width: 40px;
    border: none !important;
  }
}
</style>
